import type { FeatureRoutes } from '@/app/screens'

export default {
  screens: { scripts: () => import('./ScriptsPage.vue') },
  routes: [
    { path: '/scripts/:id', component: () => import('./ScriptEditor.vue'), meta: { perm: 'script.view', navKey: 'scripts' } },
  ],
} satisfies FeatureRoutes
